import React from 'react';

import { useTheme } from '@emotion/react';

// Round done/undone indicator shared by the onboarding checklist and widget.
const StepCheck = ({
  animated,
  done,
  size,
}: {
  animated?: boolean;
  done: boolean;
  size: 'large' | 'small';
}) => {
  const theme = useTheme();
  const large = size === 'large';
  const box = large ? '2.4rem' : '1.8rem';
  const icon = large ? '14' : '10';

  return (
    <span
      aria-hidden
      css={{
        alignItems: 'center',
        background: done ? theme.colors.success : 'transparent',
        border: `2px solid ${
          done ? theme.colors.success : theme.colors.grayLight
        }`,
        borderRadius: '50%',
        color: theme.colors.white,
        display: 'inline-flex',
        flexShrink: 0,
        height: box,
        justifyContent: 'center',
        ...(animated ? { transition: 'all 0.15s' } : {}),
        width: box,
      }}
    >
      {done && (
        <svg fill="none" height={icon} viewBox="0 0 24 24" width={icon}>
          <path
            d="M5 12l4 4L19 7"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
        </svg>
      )}
    </span>
  );
};

export default StepCheck;
